import { ButtonType, ButtonWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { BackButton } from '~src/spacesPlatform/components/layout/BackButton';
import { PageHeaderStyles } from '~src/spacesPlatform/components/layout/PageHeaderStyles';

export function ConnectedApplicationBackButton() {
    const history = useHistory();
    const urls = siteUrlsSelector(getAppStore().getState());
    return <>
      <div>
        <Tooltip getContent={() => <span>{Messages.back()}</span>} position={TooltipPosition.BottomRightCorner} testId={'back-button-tooltip'}>
          <ButtonWidget
            buttonType={ButtonType.IconOutline}
            testId="back"
            handleClick={history.goBack}
            style={PageHeaderStyles.BackButton}
            getContent={state => {
              // Keep alt text blank since button has a title: TFS 1036309
              const useActiveIcon: boolean = state.hover || state.active || state.focus;
              const src = useActiveIcon ? BackButton.REGULAR_ICON_PATH_ACTIVE : BackButton.REGULAR_ICON_PATH;
              return <img width={24} height={24} src={src} style={{ border: '1px solid transparent' }} alt="" />;
            }} />
        </Tooltip>
      </div>
      <a href={urls.settingsConnectedApplicationsUrl()} onClick={history.goBack}>{Messages.connectedApplicationsBackText()}</a>
    </>;
  }